// extracted by mini-css-extract-plugin
export default {"MainBody":"FrontPageLayout_MainBody__vDSFu","Auth":"FrontPageLayout_Auth__7GNkF","FrontPageLayout":"FrontPageLayout_FrontPageLayout__GQOGs"};